import taskMutations from '@/common/vuex/mutations/task';

export default {
  ...taskMutations,
};
